import { Experiment } from '@ms/yammer-data/dist/state/types';
import { useExperimentTreatmentWithoutReporting } from '@ms/yammer-hooks/dist/experiments';
export const useIsMenuNavPhase1Enabled = () => {
    const treatment = useExperimentTreatmentWithoutReporting(Experiment.NavPhase1);
    return ['pillars_header_menu', 'pillars_header_menu_search'].includes(treatment);
};
//# sourceMappingURL=useIsMenuNavPhase1Enabled.js.map